<template>
  <div class="todo-item" :class="{ editing: editingStatus }">
    <input
      type="radio"
      :checked="todo.status === TodoStatus.Completed"
      @click="todoService.toggleTodoStatus(todo)"
    />
    <span
      @dblclick="toggleStatus()"
      class="text-todo-name"
      :class="{ 'text-del': todo.status === TodoStatus.Completed }"
      >{{ todo.name }}</span
    >
    <button class="btn-del" type="button" @click="todoService.removeTodo(todo)">
      删除
    </button>
    <input
      ref="inputRef"
      type="text"
      class="local-input"
      v-model="editingValue"
      @keypress.enter="updateTodo()"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, Ref, nextTick } from "vue";

import { useService } from "use-vue-service";

import { TodoStatus, Todo, TodoService } from "@/services/todo.service";

export default defineComponent({
  props: {
    todo: {
      type: Object as PropType<Todo>,
      required: true
    }
  },
  setup(props) {
    const inputRef: Ref<HTMLInputElement | null> = ref(null);
    const editingStatus = ref(false);
    const editingValue = ref(props.todo.name);
    const todoService = useService(TodoService);
    const toggleStatus = async () => {
      editingStatus.value = !editingStatus.value;
      if (editingStatus.value) {
        await nextTick();
        inputRef.value?.focus();
      }
    };
    const updateTodo = () => {
      todoService.updateTodo(props.todo, editingValue.value);
      toggleStatus();
    };
    return {
      todoService,
      TodoStatus,
      editingValue,
      updateTodo,
      editingStatus,
      toggleStatus,
      inputRef
    };
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.todo-item {
  line-height: 32px;
  border-bottom: 1px solid #666;
  color: #222;

  .text-del {
    text-decoration: line-through;
    color: #999;
  }
  .btn-del {
    display: none;
    float: right;
    margin-top: 3px;
  }
  &:hover .btn-del {
    display: inline-block;
  }
  .local-input {
    display: none;
  }

  &.editing {
    input[type="radio"] {
      opacity: 0;
    }
    .text-todo-name {
      display: none;
    }
    .btn-del {
      display: none;
    }
    .local-input {
      display: inline-block;
    }
  }
}
</style>
